<template>
  <div class="BidToday">
    <div style="text-align: center;font-size:1.6em;font-weight: bold;">竞价时间</div>
    <div class="bidList">
      <div class="bidItems" v-for="(val, key, i) in Bid" :key="i">
        <div class="itemTime">
          {{ key }}
        </div>
        <div class="todayBid">
          <div class="itemInfo" v-for="item in val" :key="item.projectname">
            <div class="title">{{ item.projectname }}</div>
            <div class="time">{{ item.prsbjbegtime | fontmate }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import request from '../utils/request'
import dayjs from 'dayjs'
export default {
  name: "BidToday",
  data() {
    return {
      Bid: {}
    }
  },
  mounted() {
    this.getProjectBid()
  },
  filters: {
    fontmate(val) {
      return dayjs(val).format("MM-DD HH:mm:ss")
    }
  },
  methods: {
    async getProjectBid() {

      let res = await request({
        url: "/web/web/getProjectBid",
        method: "get",
        params: { cosid: this.cosId },
      });
      this.Bid = this.sordProject(res)
    },
    sordProject(List) {
      // console.log('-------Li', List)
      let sord = {}
      // let sordList = []
      List.forEach(item => {
        item.time = dayjs(item.prsbjbegtime).format("YYYY-MM-DD")
        if (sord[item.time]) {
          sord[item.time].push(item)
        } else {
          sord[item.time] = [item]
        }
      });
      return sord
    }
  },
  computed: {
    ...mapGetters(['cosId'])
  }
}
</script>

<style lang="scss" scoped>
.BidToday {
  padding: .6em .6em;
  background-color: #f1f1f1;

  .bidList {
    .bidItems {
      margin: .6em 0;
      padding: .6em .6em;
      border-radius: .6em;
      background-color: #fff;

      .itemTime {
        font-size: 1.3em;
        font-weight: bold;
        margin-bottom: .6em;
      }

      .todayBid {
        .itemInfo {
          margin-bottom: .6em;
          display: flex;

          .title {
            width: 12em;

            white-space: nowrap;

            overflow: hidden;

            text-overflow: ellipsis;
          }

          .time {
            margin-left: 1.6em;
          }
        }
      }
    }
  }
}
</style>
